/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataStructureGraphIcon16Light = forwardRef('DataStructureGraphIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 3.5A2.5 2.5 0 0 1 3.5 1h6a2.5 2.5 0 0 1 0 5H7.51l2.229 3H12.5a2.5 2.5 0 0 1 0 5h-6a2.5 2.5 0 0 1 0-5h1.993l-2.23-3H3.5A2.5 2.5 0 0 1 1 3.5ZM3.5 2a1.5 1.5 0 1 0 0 3h6a1.5 1.5 0 0 0 0-3h-6Zm3 8a1.5 1.5 0 0 0 0 3h6a1.5 1.5 0 0 0 0-3h-6Z" })));
});
